<template>
  <div>
    <a-from>
      <a-form-item name='grade_gift_is_store' style="margin-bottom: 0;" :wrapper-col="{span:23}">
        <div class="s_flex_ali">
          <p class="width-120">领取方式</p>
          <a-checkbox v-model:checked="privilegesDetail.grade_gift_is_core_express" @change='privilegesDetail.grade_gift_is_core_express = privilegesDetail.grade_gift_is_core_express?1:0;privilegesDetail.grade_gift_is_core_express'>
            总部配送
          </a-checkbox>
          <a-checkbox v-model:checked="privilegesDetail.grade_gift_is_store" @change='privilegesDetail.grade_gift_is_store = privilegesDetail.grade_gift_is_store?1:0'>
            门店核销
          </a-checkbox>
        </div>
        (门店核销订单可在订单-订单设置中配置）
        <a-table class="m-t-15 m-b-15" :pagination='false' bordered align="center" rowKey='id' :columns='columns' :data-source='privilegesDetail.grade_gift_data' v-if="!showTable">
          <template v-slot:gift="{record}">
            <div v-if="record.gift_info.length==0">不派发礼品</div>
            <div v-else-if="record.gift_info.length==1">
              <a-card-meta>
                <template #avatar>
                  <img :src="info.picdomain+'/'+record.gift_info[0].image_url" alt="" style="width:50px;height: 50px;object-fit:cover">
                </template>
                <template #description>{{record.gift_info[0].gift_name}}</template>
              </a-card-meta>
            </div>
            <div v-else-if="record.gift_info.length">
              <a-card-meta>
                <template #avatar>
                  <img :src="info.picdomain+'/'+v.image_url" alt="" style="width:50px;height: 50px;object-fit:cover;margin-right:5px"  v-for="(v,k) in record.gift_info" :key="k">
                </template>
              </a-card-meta>
            </div>
          </template>
          <template v-slot:action="{record,index}">
            <a-button type="link" @click='editDateGift(record,index)'>编辑</a-button>
          </template>
        </a-table>
        <div class="s_flex_ali">
          <div class="s_flex_ali">
            <p class="width-120">
              运费设置
            </p>
            <selectFreight v-model:value="privilegesDetail.grade_gift_express_id" :id="privilegesDetail.grade_gift_express_id" />
          </div>
        </div>

      </a-form-item>
    </a-from>
    <!-- 编辑礼品 -->
    <a-modal :keyboard="false" title="编辑礼品" v-model:visible="showTable" centered :width='1300' :footer="null" destroyOnClose>
      <a-button type="primary" @click="showGift=true">
        <PlusOutlined />
        添加礼品
      </a-button>
      <a-table class="m-t-15 m-b-15" :pagination='false' bordered align="center" rowKey='id' :columns='columns1' :data-source='giftData.gift_info'>
        <template v-slot:action="{index}">
          <a-button type="link" @click='delGood(index,"good")'>删除</a-button>
        </template>
      </a-table>
    </a-modal>

    <a-modal :keyboard="false" title="选择礼品" v-model:visible="showGift" centered :width='1300' :footer="null" destroyOnClose>
      <selectBaseGiftSku :checkout="true" :max="3" v-on:select="giftSelect" :selectList="giftData.gift_info" />
    </a-modal>
  </div>
</template>

<script>
import { reactive, ref, toRefs } from "@vue/reactivity";
import { inject, onMounted, watch } from "@vue/runtime-core";
import store from "@/store";
const columns = [
  {
    title: "月份",
    dataIndex: "title",
    key: "title",
    width: 150,
  },
  {
    title: "礼品",
    dataIndex: "gift_info",
    key: "gift_info",
    slots: { customRender: "gift" },
  },
  {
    title: "操作",
    key: "action",
    width: 140,
    slots: { customRender: "action" },
  },
];
const columns1 = [
  {
    title: "礼品名称",
    dataIndex: "gift_name",
    key: "gift_name",
  },
  {
    title: "规格",
    dataIndex: "spec_value",
    key: "spec_value",
  },
  {
    title: "操作",
    key: "action",
    slots: { customRender: "action" },
  },
];

export default {
  props: {
    privileges: Object,
  },
  setup(props, { emit }) {
    const state = reactive({
      info: store.state.user.info,
      list: [],
      showTable: false,
      showGift: false,
      shareList: [],
    });
    const privilegesDetail = ref({
      grade_gift_is_core_express: 0,
      grade_gift_is_store: 0,
      grade_gift_express_id: null,
    });
    const _lodash = inject("_lodash");
    watch(
      () => privilegesDetail.value,
      (state) => {
        console.log(state)
        emit("update:value", {
          grade_gift_data:state.grade_gift_data,
          grade_gift_is_core_express:state.grade_gift_is_core_express,
          grade_gift_express_id:state.grade_gift_express_id,
          grade_gift_is_store:state.grade_gift_is_store
        });
      },
      { deep: true }
    );
    onMounted(() => {
      privilegesDetail.value = _lodash.cloneDeep(props.privileges);
           emit("update:value", {
          grade_gift_data:privilegesDetail.value.grade_gift_data,
          grade_gift_is_core_express:privilegesDetail.value.grade_gift_is_core_express,
          grade_gift_express_id:privilegesDetail.value.grade_gift_express_id,
          grade_gift_is_store:privilegesDetail.value.grade_gift_is_store
        });
    });
    // 选择修改礼品
    const giftData = ref({});
    const giftIndex = ref(0);
    const editDateGift = (data, index) => {
      giftData.value = data;
      giftIndex.value = index;
      state.showTable = true;
    };
    const giftSelect = (data) => {
      giftData.value.gift_info = data;
      privilegesDetail.value.grade_gift_data[giftIndex.value] = giftData.value;
      state.showGift = false;
    };
    // 删除
    const delGood = (index) => {
      giftData.value.gift_info.splice(index, 1);
    };
    return {
      ...toRefs(state),
      columns,
      columns1,
      privilegesDetail,
      giftSelect,
      editDateGift,
      giftData,
      delGood,
    };
  },
};
</script> 